import React from 'react';
import { Link } from 'react-router-dom';
import { partnerFirms, adjacencyPages } from '../data/siteContent';

export default function Partners() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-8">
        <header className="space-y-4">
          <p className="text-sm uppercase tracking-[0.4em] text-gray-500">Advisor partnerships</p>
          <h1 className="text-4xl font-bold text-charcoal">Trusted partner network</h1>
          <p className="text-gray-600">
            We co-create referral programs, review co-branded content, and deliver the compliance documentation advisors need to feel confident promoting our tax strategies.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-2">
          {partnerFirms.map((partner) => (
            <article key={partner.name} className="rounded-3xl border border-gray-200 bg-gray-warm p-6">
              <p className="text-sm text-gray-500">Advisor focus</p>
              <h2 className="text-2xl font-semibold text-charcoal">{partner.name}</h2>
              <p className="text-gray-600 mt-2">{partner.description}</p>
            </article>
          ))}
        </div>

        <section className="rounded-3xl border border-primary/40 bg-white p-8 shadow-lg">
          <h2 className="text-2xl font-semibold text-charcoal">Partner program</h2>
          <p className="text-gray-600 mt-3">
            Advisors receive prep-ready materials, joint webinars, and a private partner portal. Share a client, and we co-manage the strategy, keeping the lead with your practice.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            {adjacencyPages.slice(0, 3).map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="rounded-full border border-primary px-4 py-2 text-sm font-semibold text-primary hover:bg-primary/10"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
